module.exports = __webpack_public_path__ + "static/img/industries12.cb18cdd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industries12.jpg
// module id = ORLN
// module chunks = 1